import { Card, Col, Container, Form, Row } from "react-bootstrap";
import HeatmapChartStatistics from "./StatisticsChart/HeatmapChartStatistics";
import PieChartStatistics from "./StatisticsChart/PieChartStatistics";
import ColumnChartStatistics from "./StatisticsChart/ColumnChartStatistics";
import UserActivityLogsData from "./StatisticsTables/UserActivityLogsData";
import SitePerformanceSummaryData from "./StatisticsTables/SitePerformanceSummaryData";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";

const SDVStatisticsDataList = () => {
  const [siteHitMap, setSiteHitMap] = useState([]);
  const [siteHitMapLoader, setSiteHitMapLoader] = useState(false);
  const [chartLoader, setChartLoader] = useState(false);
  const [sitePerformanceLoader, setSitePerformanceLoader] = useState(false);
  const [sitePerformance, setSitePerformance] = useState([]);
  const [userActivityLoader, setUserActivityLoader] = useState(false);
  const [userActivity, setUserActivity] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [SDVList, setSDVList] = useState([]);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const getStudyFormSiteWiseTotalSDV = async () => {
    setChartLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyFormSiteWiseTotalSDV(userData)
    setSiteList(data?.site || [])
    setSDVList(data?.sdv || [])
    setChartLoader(false)
  }

  const getStudyFormSiteWiseTotalFormLevelSDV = async () => {
    setSiteHitMapLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyFormSiteWiseTotalFormLevelSDV(userData)
    setSiteHitMap(data?.data || [])
    setSiteHitMapLoader(false)
  }

  const getStudySitePerformanceSDVSummery = async () => {
    setSitePerformanceLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudySitePerformanceSDVSummery(userData)
    setSitePerformance(data?.data || [])
    setSitePerformanceLoader(false)
  }

  const getStudyUserActivitySDVSummery = async () => {
    setUserActivityLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyUserActivitySDVSummery(userData)
    setUserActivity(data?.data || [])
    setUserActivityLoader(false)
  }

  useEffect(() => {
    getStudyFormSiteWiseTotalSDV()
    getStudyFormSiteWiseTotalFormLevelSDV()
    getStudySitePerformanceSDVSummery()
    getStudyUserActivitySDVSummery()
  }, []);
  return (
    <>
      <div className="overflow-auto pt-2" style={{ height: "calc(100vh - 145px)" }}>
        <Container fluid>
          <Row>
            <Form.Group as={Col} md={12} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body className="p-0">
                  <HeatmapChartStatistics
                    siteHitMap={siteHitMap}
                    siteHitMapLoader={siteHitMapLoader}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={4} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body className="p-0">
                  <PieChartStatistics
                    siteList={siteList}
                    SDVList={SDVList}
                    chartLoader={chartLoader}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={8} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body className="p-0">
                  <ColumnChartStatistics
                    siteList={siteList}
                    SDVList={SDVList}
                    chartLoader={chartLoader}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body>
                  <SitePerformanceSummaryData
                    sitePerformanceLoader={sitePerformanceLoader}
                    sitePerformance={sitePerformance}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body>
                  <UserActivityLogsData
                    userActivityLoader={userActivityLoader}
                    userActivity={userActivity}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SDVStatisticsDataList;
